module.exports = __webpack_public_path__ + "static/img/IMG_0345.ed15af5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/IMG_0345.jpg
// module id = NRa8
// module chunks = 1